// How long a relay timer window keeps the relay on and off per day.
//
// Must agree with the backend's is_time_in_range(): on at `on`, off at `off`,
// wrapping past midnight when off is earlier than on (22:00 -> 06:00). Equal
// times mean "never on", because the backend's start <= now < end is then empty.

const DAY_MINUTES = 24 * 60;

const toMinutes = (hhmm) => {
  const match = /^(\d{1,2}):(\d{2})$/.exec(hhmm || '');
  if (!match) return null;
  return Number(match[1]) * 60 + Number(match[2]);
};

export const windowMinutes = (on, off) => {
  const start = toMinutes(on);
  const end = toMinutes(off);
  if (start === null || end === null) return null;
  const onMinutes = (end - start + DAY_MINUTES) % DAY_MINUTES;
  return { onMinutes, offMinutes: DAY_MINUTES - onMinutes };
};

export const formatMinutes = (minutes) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (!m) return `${h} h`;
  if (!h) return `${m} m`;
  return `${h} h ${m} m`;
};

// "On 12 h · Off 12 h", or null while either time is incomplete.
export const describeWindow = (on, off) => {
  const w = windowMinutes(on, off);
  if (!w) return null;
  return `On ${formatMinutes(w.onMinutes)} · Off ${formatMinutes(w.offMinutes)}`;
};

export const PRESET_HOURS = [8, 10, 12, 14, 16];

// The off time that gives `hours` of light starting at `on` ("06:00" + 12 -> "18:00").
export const offAfter = (on, hours) => {
  const start = toMinutes(on);
  if (start === null) return null;
  const end = (start + hours * 60) % DAY_MINUTES;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(Math.floor(end / 60))}:${pad(end % 60)}`;
};
